

export enum AppConfigFields {
    Discounts = 'discounts',
    MinimumPurchaseAmount = 'minimumPurchaseAmount',
    MinimumPurchaseQuantity = 'minimumPurchaseQuantity',
    ContactData = 'contactData'
}


export enum ContactInfoFields {
    Whatsapp = 'whatsapp',
    Phone = 'phone',
    Email = 'email',
    Address = 'address',
    Instagram = 'instagram',
    StoreInfo = 'storeInfo',
    WhatsappMessage = 'whatsappMessage'
}

export interface ContactInfo {
    [ContactInfoFields.Whatsapp]?: string;
    [ContactInfoFields.Phone]?: string;
    [ContactInfoFields.Email]?: string;
    [ContactInfoFields.Address]?: string;
    [ContactInfoFields.Instagram]?: string;
    [ContactInfoFields.StoreInfo]?: string;
    [ContactInfoFields.WhatsappMessage]?: string;
}

export interface DiscountTier {
    percent: string;
    threshold: string;
}


export interface AppConfig {
    [AppConfigFields.Discounts]: DiscountTier[];
    [AppConfigFields.MinimumPurchaseAmount]: number;
    [AppConfigFields.MinimumPurchaseQuantity]: number;
    [AppConfigFields.ContactData]: ContactInfo;
}














